import React, {Component} from 'react';
import {render} from 'react-dom';

export default class Footer extends Component {
    render() {
        return (
            <div className="container-fluid padding-lr55 bg-form">
                <div className="row">
                    <div className="col-xs-12 text-center text-muted padding-tb10">
                        All bookings are subject to the terms and conditions of your Customer Contract with Deadline.
                        Delivery times may be delayed by factors outside Deadline's control.
                        <br/>
                        If you wish to cancel or modify an existing job, please contact Deadline on +64 9 357 1995 with your Job Number ready.
                        <br/>
                        <b>Nationwide service prices are subject to change. Additional weight, large items, multiple items and rural deliveries maybe subject to additional charges. Rural deliveries take 2-3 working days.</b>
                    </div>
                </div>
            </div>
        )
    }
}